<table
  [id]="tableId"
  mat-table
  [dataSource]="dataSource"
  class="mat-elevation-z8 editable-table"
>
  <!-- Columns -->
  <ng-container *ngFor="let column of columns" [matColumnDef]="column.id">
    <th
      class="editable-table-th"
      mat-header-cell
      *matHeaderCellDef
      [innerHtml]="column.text"
    ></th>
    <td class="editable-table-td" mat-cell *matCellDef="let element">
      <!-- VERIFICA O ESTADO DO GRID -->
      <ng-container [ngSwitch]="element.state">
        <!-- CASO EDIÇÃO -->
        <ng-container *ngSwitchCase="elementeState.EDIT">
          <!-- VERIFICA O TIPO DO COMPONENTE -->
          <ng-container [ngSwitch]="column.type">
            <!-- CASO NONE -->
            <ng-container *ngSwitchCase="columnType.NONE">
              <ng-container [ngSwitch]="column.filter">
                <ng-container *ngSwitchCase="filterOption.NONE"></ng-container>
                <ng-container *ngSwitchCase="filterOption.CNPJ">
                  {{ element[column.id] | MaskCnpjPipe }}
                </ng-container>
                <ng-container *ngSwitchCase="filterOption.DATA">
                  {{ element[column.id] | datex : 'DD/MM/YYYY' }}
                </ng-container>
                <ng-container *ngSwitchCase="filterOption.AUTOCOMPLETE">
                  {{ element[column.params.displayText] }}
                </ng-container>
                <ng-container *ngSwitchDefault>{{
                  element[column.id]
                }}</ng-container>
              </ng-container>
            </ng-container>
            <!-- CASO TEXTBOX -->
            <ng-container *ngSwitchCase="columnType.TEXTBOX">
              <ng-container
                *ngIf="
                  element.disabledColumns && element.disabledColumns[column.id]
                "
              >
                <div
                  class="form-control disabled custom-form-group disabled"
                  [matTooltip]="column.params?.disabledTooltip"
                ></div>
              </ng-container>
              <ng-container
                *ngIf="
                  !(
                    element.disabledColumns &&
                    element.disabledColumns[column.id]
                  )
                "
              >
                <input
                  [name]="column.id"
                  type="text"
                  [class.invalid-input]="
                    element.invalidColumns && element.invalidColumns[column.id]
                  "
                  [(ngModel)]="element[column.id]"
                  [mask]="column.params?.mask"
                  (blur)="isValid(column, element)"
                  class="form-control custom-form-group"
                  [placeholder]="column.text"
                />
              </ng-container>
            </ng-container>
            <!-- CASO SELECT -->
            <ng-container *ngSwitchCase="columnType.SELECT">
              <select
                [(ngModel)]="element[column.id]"
                [class.invalid-input]="
                  element.invalidColumns && element.invalidColumns[column.id]
                "
                class="form-control custom-form-group"
              >
                <option disabled value="">Selecione</option>
                <option *ngFor="let item of column.params" [value]="item.id">
                  {{ item.text }}
                </option>
              </select>
            </ng-container>
            <!-- CASO CUSTOM -->
            <ng-container *ngSwitchCase="columnType.CUSTOM1">
              <ng-container
                *ngIf="customColumnRef1"
                [ngTemplateOutlet]="customColumnRef1"
                [ngTemplateOutletContext]="{ $implicit: rowDetail }"
              >
              </ng-container>
            </ng-container>
            <!-- CASO DATEPICKER -->
            <ng-container *ngSwitchCase="columnType.DATEPICKER">
              <!-- <app-datepicker [valor]="element[column.id]" [class.invalid-input]="(element.invalidColumns && element.invalidColumns[column.id])" 
                                [configDatePicker]="configDatePicker" [css]="(element.invalidColumns && element.invalidColumns[column.id]) ? 'input-datepicker invalid-input' : 'input-datepicker'"
                                (dataInvalida)="changeDate($event, column, element)" (dataSelecionada)="changeDate($event, column, element)">
                            </app-datepicker> -->
              <div class="d-flex" style="padding-top: 20px; max-width: 160px">
                <ids-form-field errorMessage="data inválida">
                  <input
                    idsDatepicker
                    [noLabel]="true"
                    [value]="element[column.id] | datex : 'DD/MM/YYYY'"
                    (valueChange)="changeDate($event, column, element)"
                    [max]="dataMaxima"
                    [canPush]="true"
                  />
                </ids-form-field>
              </div>
            </ng-container>
            <!-- CASO AUTOCOMPLETE -->
            <ng-container *ngSwitchCase="columnType.AUTOCOMPLETE">
              <app-autocomplete
                [options]="column.params.options"
                [class.invalid-input]="
                  element.invalidColumns && element.invalidColumns[column.id]
                "
                [isMaskCnpj]="false"
                [selectedText]="element[column.id]"
                [showId]="column.params.showId"
                [showFilter]="column.params.showFilter"
                (selectedValue)="
                  autocompleteSelectedValue($event, column, element)
                "
                [displayText]="column.params.displayText"
                [displayValue]="column.params.displayValue"
              >
              </app-autocomplete>
            </ng-container>
            <!-- CASO CHECKBOX -->
            <ng-container *ngSwitchCase="columnType.CHECKBOX">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selectItem(element) : null"
                [checked]="selection.isSelected(element)"
                [aria-label]="checkboxLabel(element)"
                [class.invalid-input]="
                  element.invalidColumns && element.invalidColumns[column.id]
                "
              >
              </mat-checkbox>
            </ng-container>
            <!-- CASO DEFAULT_ACTIONS -->
            <ng-container *ngSwitchCase="columnType.DEFAULT_ACTIONS">
              <i class="editable-table-icon" (click)="cancelEditItem(element)"
                ></i
              >
              <i class="editable-table-icon" (click)="saveItem(element)"></i>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- CASO VISUALIZAÇÃO -->
        <ng-container *ngSwitchDefault>
          <!-- VERIFICA O TIPO DO COMPONENTE -->
          <ng-container [ngSwitch]="column.type">
            <!-- CASO CHECKBOX -->
            <ng-container *ngSwitchCase="columnType.CHECKBOX">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selectItem(element) : null"
                [checked]="selection.isSelected(element)"
                [aria-label]="checkboxLabel(element)"
                [class.invalid-input]="
                  element.invalidColumns && element.invalidColumns[column.id]
                "
              >
              </mat-checkbox>
            </ng-container>
            <ng-container *ngSwitchCase="columnType.DEFAULT_ACTIONS">
              <i class="editable-table-icon" (click)="editItem(element)"></i>
              <i class="editable-table-icon" (click)="deleteItem(element)"></i>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container [ngSwitch]="column.filter">
              <ng-container *ngSwitchCase="filterOption.NONE"></ng-container>
              <ng-container *ngSwitchCase="filterOption.CNPJ">
                {{ element[column.id] | MaskCnpjPipe }}
              </ng-container>
              <ng-container *ngSwitchCase="filterOption.DATA">
                {{ element[column.id] | datex : 'DD/MM/YYYY' }}
              </ng-container>
              <ng-container *ngSwitchCase="filterOption.AUTOCOMPLETE">
                {{ element[column.params.displayText] }}
              </ng-container>
              <ng-container *ngSwitchDefault>{{
                element[column.id]
              }}</ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
